// import { useContext, useEffect, useState } from "react";
// import MapContext from "../Map/MapContext";
// import Control from "ol/control/Control";

// const ParkInfoControl = ({ selectedPark }) => {
//   const { map } = useContext(MapContext);
//   const [control, setControl] = useState(null);

//   useEffect(() => {
//     if (!map) {
//       console.log("ParkInfoControl: No map available");
//       return;
//     }

//     console.log("ParkInfoControl: Creating control, selectedPark:", selectedPark);

//     // Create element
//     const element = document.createElement('div');
//     element.className = 'ol-control park-info-control';
//     element.style.cssText = `
//         position: absolute;
//         top: 0.5em;
//         right: 20.5em;
//         background: rgba(255, 255, 255, 0.1); /* Very transparent background */
//         padding: 8px 12px;
//         border-radius: 4px;
//         border: 1px solid rgba(28, 23, 23, 0.3); /* Semi-transparent border */
//         box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Lighter shadow */
//         max-width: 280px;
//         font-family: Times New Roman, sans-serif;
//         z-index: 1000;
//         backdrop-filter: none; /* Remove blur */
//      `;
//     // Create control
//     const parkInfoControl = new Control({
//       element: element
//     });

//     // Add control to map
//     map.addControl(parkInfoControl);
//     setControl(parkInfoControl);
//     console.log("ParkInfoControl: Control added successfully");

//     return () => {
//       if (parkInfoControl && map) {
//         map.removeControl(parkInfoControl);
//         console.log("ParkInfoControl: Control removed");
//       }
//     };
//   }, [map]); // Only depend on map

//   // Separate effect to update content when selectedPark changes
//   useEffect(() => {
//     if (control && control.element) {
//       const element = control.element;
      
//       if (selectedPark) {
//         element.innerHTML = `
//           <div style="font-weight: bold; color: #000080; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 4px;">
//             ${'Park Information'}
//           </div>
//           <div style="color: #333; font-size: 12px; line-height: 1.4;">
//             ${selectedPark.name ? `<div><strong>Park Name:</strong> ${selectedPark.name}</div>` : ''}
//             ${selectedPark.region ? `<div><strong>Region:</strong> ${selectedPark.region}</div>` : ''}
//             ${selectedPark.city ? `<div><strong>City:</strong> ${selectedPark.city}</div>` : ''}
//             ${selectedPark.woreda ? `<div><strong>Woreda:</strong> ${selectedPark.woreda}</div>` : ''}
//             ${selectedPark.distance_from_capital ? `<div><strong>Diatance from Capital(km):</strong> ${selectedPark.distance_from_capital}</div>` : ''}
//             ${selectedPark.zone ? `<div><strong>Zone:</strong> ${selectedPark.zone}</div>` : ''}
//             ${selectedPark.specialization ? `<div><strong>Specialization:</strong> ${selectedPark.specialization}</div>` : ''}
//             ${selectedPark.developed_by ? `<div><strong>Developed By:</strong> ${selectedPark.developed_by}</div>` : ''}
//             ${selectedPark.area_on_plan ? `<div><strong>Area(hect):</strong> ${selectedPark.area_on_plan}</div>` : ''}
//             ${selectedPark.current_status ? `<div><strong>Status:</strong> ${selectedPark.current_status}</div>` : ''}
//             ${selectedPark.description ? `<div style="margin-top: 6px;"><strong>Description:</strong> ${selectedPark.description}</div>` : ''}
//           </div>
//         `;
//       } else {
//         element.innerHTML = `
//           <div style="font-weight: bold; color: #000080; font-size: 14px; margin-bottom: 4px;">
//             Park Information
//           </div>
//           <div style="color: #666; font-size: 12px; line-height: 1.3;">
//             Select a park from the dropdown to view detailed information.
//           </div>
//         `;
//       }
//     }
//   }, [selectedPark, control]);

//   return null;
// };

// export { ParkInfoControl };
import { useContext, useEffect, useState } from "react";
import MapContext from "../Map/MapContext";
import Control from "ol/control/Control";
import { GetDataFromApiWithParams } from "../../../../../../services/api/ExecuteApiRequests";

const ParkInfoControl = ({ selectedPark }) => {
  const { map } = useContext(MapContext);
  const [control, setControl] = useState(null);
   const [parcelSummary, setParcelSummary] = useState(null);
  

  useEffect(() => {
    if (!map) {
      console.log("ParkInfoControl: No map available");
      return;
    }

    console.log("ParkInfoControl: Creating control, selectedPark:", selectedPark);

    // Create element
    const element = document.createElement('div');
    element.className = 'ol-control park-info-control';
    element.style.cssText = `
        position: absolute;
        top: 0.5em;
        right: 20.5em;
        background: rgba(255, 255, 255, 0.1); /* Very transparent background */
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid rgba(28, 23, 23, 0.3); /* Semi-transparent border */
        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Lighter shadow */
        max-width: 280px;
        font-family: Times New Roman, sans-serif;
        z-index: 1000;
        backdrop-filter: none; /* Remove blur */
     `;
    // Create control
    const parkInfoControl = new Control({
      element: element
    });

    // Add control to map
    map.addControl(parkInfoControl);
    setControl(parkInfoControl);
    console.log("ParkInfoControl: Control added successfully");

    return () => {
      if (parkInfoControl && map) {
        map.removeControl(parkInfoControl);
        console.log("ParkInfoControl: Control removed");
      }
    };
  }, [map]); // Only depend on map

  // Separate effect to update content when selectedPark changes
useEffect(() => {
  const fetchParcelData = async () => {
    if (selectedPark && selectedPark.id) {
      try {
        console.log("🔄 Fetching parcel data for park:", selectedPark.id);
        const resultData = await GetDataFromApiWithParams(`availableParcel/${selectedPark.id}`);
        console.log("📦 API Response:", resultData);
        
        if (resultData && resultData.length > 0) {
          console.log("✅ Setting parcel summary:", resultData[0]);
          setParcelSummary(resultData[0]); // Note: resultData is an array, take first item
        } else {
          console.log("⚠️ No data received");
          setParcelSummary(null);
        }
      } catch (error) {
        console.error("❌ Failed to fetch parcel data:", error);
        setParcelSummary(null);
      }
    }
  };

  fetchParcelData();
}, [selectedPark]); // Add selectedPark as dependency

// Add another useEffect to log when parcelSummary changes
useEffect(() => {
  console.log("📊 parcelSummary updated:", parcelSummary);
}, [parcelSummary]);

// Separate useEffect for updating the control element
useEffect(() => {
  if (control && control.element) {
    const element = control.element;
    
    console.log("🎯 Updating control with parcelSummary:", parcelSummary);

    if (selectedPark) {
      element.innerHTML = `
        <div style="font-weight: bold; color: #000080; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 4px;">
          ${'Park Information'}
        </div>
        <div style="color: #333; font-size: 12px; line-height: 1.4;">
          ${selectedPark.name ? `<div><strong>Park Name:</strong> ${selectedPark.name}</div>` : ''}
          ${selectedPark.region ? `<div><strong>Region:</strong> ${selectedPark.region}</div>` : ''}
          ${selectedPark.city ? `<div><strong>City:</strong> ${selectedPark.city}</div>` : ''}
          ${selectedPark.woreda ? `<div><strong>Woreda:</strong> ${selectedPark.woreda}</div>` : ''}
          ${selectedPark.distance_from_capital ? `<div><strong>Distance from Capital (km):</strong> ${selectedPark.distance_from_capital}</div>` : ''}
          ${selectedPark.zone ? `<div><strong>Zone:</strong> ${selectedPark.zone}</div>` : ''}
          ${selectedPark.specialization ? `<div><strong>Specialization:</strong> ${selectedPark.specialization}</div>` : ''}
          ${selectedPark.developed_by ? `<div><strong>Developed By:</strong> ${selectedPark.developed_by}</div>` : ''}
          ${selectedPark.area_on_plan ? `<div><strong>Area on Plan (hect):</strong> ${selectedPark.area_on_plan}</div>` : ''}
          ${parcelSummary ? `<div><strong>Total Area (m²):</strong> ${parcelSummary.totalarea ? parcelSummary.totalarea.toFixed(4) : 'N/A'}</div>` : ''}
          ${parcelSummary ? `<div><strong>Available Area (percent):</strong> ${parcelSummary.availablearea ? ((parcelSummary.availablearea.toFixed(4)/parcelSummary.totalarea) *100).toFixed(2) : '0'}<strong>%:</strong></div>` : ''}
          ${parcelSummary ? `<div><strong>Hold Area (percent):</strong> ${parcelSummary.holdarea ?((parcelSummary.holdarea.toFixed(4) / parcelSummary.totalarea) *100).toFixed(2): '0'} <strong>%:</strong></div>` : ''}
          ${selectedPark.current_status ? `<div><strong>Status:</strong> ${selectedPark.current_status}</div>` : ''}
          ${selectedPark.description ? `<div style="margin-top: 6px;"><strong>Description:</strong> ${selectedPark.description}</div>` : ''}
        </div>
      `;
    } else {
      element.innerHTML = `
        <div style="font-weight: bold; color: #000080; font-size: 14px; margin-bottom: 4px;">
          Park Information
        </div>
        <div style="color: #666; font-size: 12px; line-height: 1.3;">
          Select a park from the dropdown to view detailed information.
        </div>
      `;
    }
  }
}, [selectedPark, control, parcelSummary]); // Add parcelSummary to dependencies

  return null;
};

export { ParkInfoControl };